export const PARTNERS_PAGE_TITLE = {
    FIRST_LINE: {
        REGULAR: 'МИ',
        BOLD: ' НЕ ОДНІ.',
    },
    SECOND_LINE: {
        BOLD_START: 'І ЦЕ ',
        REGULAR: 'НАША',
        BOLD_END: ' СИЛА ',
    },
};

export const PARTNERS_PAGE_SUBTITLE = 'Дякуємо тим, хто разом із нами!';

export const DOWNLOAD_ERROR = 'Не вдалося завантажити дані партнерів. Будь ласка, спробуйте пізніше.';
